var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height pa-0 ma-0"},[_c('v-col',{staticClass:"pa-0 ma-0"},[(_vm.alert)?_c('app-header-alert',{attrs:{"type":"warning","message":_vm.alert.message,"action":_vm.alert.action}}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }